import { assign, find, findIndex } from 'lodash';
import * as actions from '../constants';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  error: false,
  users: [],
  lastUpdated: false,
};

export default (state = initialState, action) => {
  let users = state.users;
  switch (action.type) {

    case actions.REQUEST_USERS:
      return assign({}, state, {
        isFetching: true,
        error: false,
        users: [],
      });

    case actions.RECEIVE_USERS:
      return assign({}, state, {
        isFetching: false,
        didInvalidate: action.error !== false,
        error: action.error,
        users: action.error === false && action.data ? action.data : [],
        lastUpdated: action.error === false ? action.date : state.lastUpdated,
      });

    case actions.REQUEST_USER:
    case actions.REQUEST_ADD_USER:
    case actions.REQUEST_USER_PERMISSIONS:
    case actions.REQUEST_USER_ACCOUNTS:
    case actions.REQUEST_ADD_DEFAULT_ACCOUNT_TO_USER:
    case actions.REQUEST_ADD_PERMISSION_TO_USER:
    case actions.REQUEST_REMOVE_PERMISSION_FROM_USER:
    case actions.REQUEST_ADD_ACCOUNT_TO_USER:
    case actions.REQUEST_REMOVE_ACCOUNT_FROM_USER:
    case actions.REQUEST_REMOVE_USER:
      return assign({}, state, {
        isFetching: true,
        error: false,
      });

    case actions.RECEIVE_USER: {
      const user = action.data;
      if (action.error === false && user) {
        const index = findIndex(users, { id: action.id });
        user.lastUpdated = action.date;
        if (index !== -1) {
          users.splice(index, 1, user);
        } else {
          users = [user, ...users];
        }
      }
      return assign({}, state, {
        users,
        isFetching: false,
        didInvalidate: action.error !== false,
        error: action.error,
      });
    }

    case actions.RECEIVE_ADD_USER: {
      const user = action.data;
      if (action.error === false && user) {
        users.unshift(user);
      }
      return assign({}, state, {
        users,
        isFetching: false,
        didInvalidate: action.error !== false,
        error: action.error,
      });
    }

    case actions.RECEIVE_USER_PERMISSIONS: {
      const permissions = action.data;
      if (action.error === false && permissions) {
        const index = findIndex(users, { id: action.id });
        const user = find(users, { id: action.id }) || { id: action.id };
        user.lastUpdated = action.date;
        user.permissions = permissions;
        if (index !== -1) {
          users.splice(index, 1, user);
        } else {
          users = [user, ...users];
        }
      }
      return assign({}, state, {
        users,
        isFetching: false,
        didInvalidate: action.error !== false,
        error: action.error,
      });
    }

    case actions.RECEIVE_ADD_PERMISSION_TO_USER: {
      if (action.error === false && action.data) {
        const index = findIndex(users, { id: action.id });
        const user = find(users, { id: action.id }) || { id: action.id };
        user.lastUpdated = action.date;
        if (!Array.isArray(user.permissions)) {
          user.permissions = [];
        }
        user.permissions.push({ permission: action.permission });
        if (index !== -1) {
          users.splice(index, 1, user);
        } else {
          users = [user, ...users];
        }
      }
      return assign({}, state, {
        users,
        isFetching: false,
        didInvalidate: action.error !== false,
        error: action.error,
      });
    }

    case actions.RECEIVE_REMOVE_PERMISSION_FROM_USER: {
      if (action.error === false && action.data) {
        const index = findIndex(users, { id: action.id });
        const user = find(users, { id: action.id }) || { id: action.id };
        user.lastUpdated = action.date;
        if (Array.isArray(user.permissions)) {
          const permissionIndex = findIndex(user.permissions, { permission: action.permission });
          user.permissions.splice(permissionIndex, 1);
        }
        if (index !== -1) {
          users.splice(index, 1, user);
        } else {
          users = [user, ...users];
        }
      }
      return assign({}, state, {
        users,
        isFetching: false,
        didInvalidate: action.error !== false,
        error: action.error,
      });
    }

    case actions.RECEIVE_USER_ACCOUNTS:
    case actions.RECEIVE_ADD_DEFAULT_ACCOUNT_TO_USER:
    case actions.RECEIVE_REMOVE_ACCOUNT_FROM_USER:
    case actions.RECEIVE_ADD_ACCOUNT_TO_USER: {
      if (action.error === false && action.data) {
        const index = findIndex(users, { id: action.id });
        const user = find(users, { id: action.id }) || { id: action.id };
        user.lastUpdated = action.date;
        user.accounts = action.data;
        if (index !== -1) {
          users.splice(index, 1, user);
        } else {
          users = [user, ...users];
        }
      }
      return assign({}, state, {
        users,
        isFetching: false,
        didInvalidate: action.error !== false,
        error: action.error,
      });
    }

    case actions.RECEIVE_REMOVE_USER: {
      if (action.error === false) {
        const index = findIndex(users, { id: action.id });
        users.splice(index, 1);
      }
      return assign({}, state, {
        users,
        isFetching: false,
        didInvalidate: action.error !== false,
        error: action.error,
      });
    }

    case actions.SHOW_USER_ERROR:
      return assign({}, state, {
        didInvalidate: true,
        error: action.error,
      });

    case actions.CLEAR_USER_ERRORS:
      return assign({}, state, {
        didInvalidate: false,
        error: false,
      });

    default:
      return state;
  }
};
